export class SelectionItem {
    value: any;
    id?: any;
    text: string;
    tooltipText?: string;
    selected?: boolean;
    expanded?: boolean;
    partialSelected?: boolean;
    parent?: SelectionItem;
    children?: SelectionItem[];
    aktiv?: boolean;
}
